import { useQuery } from "@tanstack/react-query";
import { useContext } from "react";
import { RxCalendar } from "react-icons/rx";
import { AuthContext } from "../../../contexts/AuthContext";
import { handleCountBookings } from "../../../apis/bookings";

export default function PendingWidget() {
  const { site } = useContext(AuthContext);

  const { data: count } = useQuery({
    queryKey: ["pendingCount", site?._id],
    queryFn: () =>
      handleCountBookings({
        site: site?._id === 0 ? "" : site?._id,
        isConfirmed: 0,
        isFulfilled: 0,
      }),
  });

  return (
    <div className="col-span-12 sm:col-span-6 md:col-span-3 border p-2 border-gray-300 bg-red-100">
      <div className="flex">
        <div className="flex justify-center items-center w-14 h-14 bg-red-200 border border-red-300">
          <RxCalendar size={34} />
        </div>
        <div className="flex flex-col border-l border-red-300 pl-2 ml-2">
          <div className="uppercase">Pending Bookings</div>
          <div className="font-bold text-2xl">{count}</div>
        </div>
      </div>
    </div>
  );
}
